import { useEffect, useRef } from 'react';
import './index.scss';
import { useDispatch } from 'react-redux';
import { headerActions } from '@/reducers/HeaderConfigs';
import rightContentBlack from '@/images/header/icon_share_black.png';
import Loading from '@/components/Loading';
import '@/scss/quill.bubble.css'; //富文本显示样式集合

const Index = () => {
  const dispatch = useDispatch();
  const loadingRef = useRef<any>(); //loading

  useEffect(() => {
    loadingRef.current.open();
    setTimeout(() => {
      loadingRef.current.close();
    }, 1500);
    dispatch(
      headerActions.setHeader({
        rightContent: <img src={rightContentBlack} alt="返回" />,
        rightClick: async () => {
          console.log('你好我点击了');
        },
      })
    );
  });
  return (
    <div className="myindex">
      <p>欢迎使用</p>
      <Loading cRef={loadingRef} />
    </div>
  );
};

export default Index;
